$(document).ready(function() {
    console.log('running dekstech');
  $('body').on('change','.bundle-radio',function(){
    var thisValue = $(this).attr('value');
    console.log('clicked and ym index is ' + thisValue);
    if (thisValue === 'single') {
      $('.js-qty__wrapper').find('input').val(1);
    }
    else if (thisValue === 'double') {
      $('.js-qty__wrapper').find('input').val(2);
    }
    else if (thisValue === 'triple') {
      $('.js-qty__wrapper').find('input').val(3);
    }
    else {
      
    }
  });
});